// ABOUTME: Places the 5C forgiven-sky sun in the band between the shell's rendered bottom and the horizon line.
// ABOUTME: Pure arithmetic in viewport px; the sun is 36 percent down the band, 78 percent across (88 on the phone).

export const SUN_BAND_FRACTION = 0.36;
export const SUN_X_DESKTOP_PERCENT = 78;
export const SUN_X_PHONE_PERCENT = 88;

interface SunPlacementInput {
  shellBottom: number; // viewport px: bottom of the Steersman strip, else the header
  line: number; // viewport px: the horizon line
  phone: boolean;
}

export function sunPlacement({ shellBottom, line, phone }: SunPlacementInput) {
  return {
    centreY: shellBottom + SUN_BAND_FRACTION * (line - shellBottom),
    centreXPercent: phone ? SUN_X_PHONE_PERCENT : SUN_X_DESKTOP_PERCENT,
  };
}
